export const TAG_TYPES = {
  DESTINATION: { value: "DESTINATION", name: "Destino" },
  CHARACTER: { value: "CHARACTER", name: "Personaje" },
  TRAVEL_CATEGORY: { value: "TRAVEL_CATEGORY", name: "Tipo de viaje" },
  OTHER: { value: "OTHER", name: "Otro" },
};